<template>
  <div class="d-flex">
    <v-col
      cols="12"
      md="8"
    >
      <v-card
        outlined
        class="mb-3"
      >
        <v-card-text
          v-if="stockUpdated"
          class="green "
        >
          <v-icon> mdi-check-circle</v-icon> Stocks updated !
        </v-card-text>
        <v-card-text v-else>
          <div>Update Stock</div>
          <div class="d-flex">
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="stock.product"
                :items="products"
                item-text="name"
                hide-details="auto"
                return-object
                outlined
                dense
                label="Select Product"
                selectable
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="stock.warehouse"
                :items="warehouses"
                item-text="name"
                hide-details="auto"
                return-object
                outlined
                dense
                label="Select warehouse"
              />
            </v-col>
          </div>

          <div class="d-flex">
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="stock.price"
                hide-details="auto"
                type="number"
                label="Price"
                :error-messages="priceCheck"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="stock.rackNumber"
                hide-details="auto"
                type="number"
                label="Rack Number"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-btn
                class="info"
                :disabled="pushStockDisabled"
                @click="pushStock"
              >
                Set
              </v-btn>
              <v-btn
                v-if="stocksListed"
                class="info"
                @click="updateStock"
              >
                Update
              </v-btn>
            </v-col>
          </div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Remove
                  </th>
                  <th class="text-left">
                    Item
                  </th>
                  <th class="text-left">
                    Cost
                  </th>
                  <th class="text-left">
                    Price
                  </th>
                  <th class="text-left">
                    QTY
                  </th>
                  <th class="text-left">
                    Warehouse
                  </th>
                  <th class="text-left">
                    Rack
                  </th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="cat in stocks"
                  :key="cat.product.id"
                >
                  <td>
                    <v-icon
                      small
                      color="red"
                      @click="removeStock(cat)"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td>
                    {{ cat.product.id }} {{ cat.product.name | capitalize }}
                  </td>
                  <td class="info">
                    {{ cat.product.cost | currency }}
                  </td>
                  <td class="green">
                    {{ cat.price | currency }}
                  </td>
                  <td>{{ cat.product.qty }}</td>
                  <td>{{ cat.warehouse.name }}</td>
                  <td>{{ cat.rackNumber }}</td>
                  <td>
                    <v-icon
                      small
                      color="info"
                      @click="editStock(cat)"
                    >
                      mdi-pencil
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card outlined>
        <v-card-text>
          <div>Order information</div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Item
                  </th>
                  <th class="text-left">
                    Barcode
                  </th>
                  <th class="text-left">
                    SKU
                  </th>
                  <th class="text-left">
                    QTY
                  </th>
                  <th class="text-left">
                    Unit Cost
                  </th>
                  <th class="text-left">
                    Sub Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in products"
                  :key="item.id"
                  :class="
                    'product' in stock && item.id === stock.product.id
                      ? 'active warning'
                      : ''
                  "
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.barcode }}</td>
                  <td>{{ item.sku }}</td>
                  <td :class="product.id === item.id ? 'warning' : ''">
                    {{ item.qty }}
                  </td>
                  <td class="info">
                    {{ item.cost | currency }}
                  </td>
                  <td>{{ item.subTotal | currency }}</td>
                </tr>
                <tr>
                  <td colspan="7" />
                </tr>
                <tr>
                  <td
                    colspan="5"
                    class="text-right"
                  >
                    Net Cost
                  </td>
                  <td class="">
                    {{ order.subTotal | currency }}
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="5"
                    class="text-right"
                  >
                    (-) Discount {{ order.discountRate }}%
                  </td>
                  <td class="">
                    {{ order.discountedAmount | currency }}
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="5"
                    class="text-right"
                  >
                    (+) Tax {{ order.taxRate }}%
                  </td>
                  <td class="">
                    {{ order.taxAmount | currency }}
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="5"
                    class="text-right"
                  >
                    Total Payable
                  </td>
                  <td class="">
                    {{ order.totalAmount | currency }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <payments-list :order-id="$route.params.id" />
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn :to="{ name: 'PurchaseTransaction' }">
        <v-icon>mdi-undo-variant</v-icon>
      </v-btn>

      <v-card
        outlined
        class="mt-4"
      >
        <v-card-text>
          <v-img
            :src="order.barcode"
            lazy-src="/storage/default_img/no_image.png"
            aspect-ratio="1"
            max-width="250"
            max-height="30"
          />
        </v-card-text>
        <v-card-text>
          <div class="mb-2">
            Supplier information
          </div>

          <h4>Supplier : {{ supplier.firstName }}</h4>
          <h6>Email: {{ supplier.email }}</h6>
          <h6>Identification: {{ supplier.identification }}</h6>
          <h6>Date of birth: {{ supplier.dateOfBirth }}</h6>
          <h6>Phone: {{ supplier.phone }}</h6>
          <router-link
            small
            :to="{ name: 'Products' }"
          >
            view full details
          </router-link>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import PaymentsComponent from "../common/Payments.vue";
import { mapActions } from "vuex";
export default {
  components: {
    "payments-list": PaymentsComponent,
  },
  data() {
    return {
      stockUpdated: false,
      products: [],
      order: [],
      supplier: [],
      warehouses: [],
      product: {},
      warehouse: {},
      stocks: [],
      stock: {},
    };
  },

  computed: {
    stocksListed() {
      return this.$data.stocks.length === this.$data.products.length;
    },
    priceCheck() {
      let stock = this.$data.stock;
      if ("product" in stock && stock.price < stock.product.cost) {
        return "Price should be greater then cost " + stock.product.cost;
      }
      return null;
    },
    pushStockDisabled() {
      let stock = this.$data.stock;
      return (
        !stock.price || !stock.product || !stock.warehouse || !stock.rackNumber
      );
    },
  },
  watch: {
    stocks() {
      this.$data.products.forEach((product) => {
        this.$data.stocks.forEach((stock) => {
          if (stock.product.id === product.id) {
            product.disabled = true;
          }
        });
      });
    },
  },
  mounted() {
    window.axios.get("/product-form-data").then((response) => {
      this.$data.warehouses = response.data.warehouses;
    });
    if (this.$route.params.id) {
      this.getPurchaseFromApi();
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    editStock(item) {
      this.$data.stock = item;
      this.removeStock(item);
    },
    removeStock(item) {
      let list = this.$data.stocks;
      list.splice(list.indexOf(item), 1);
    },
    pushStock() {
      this.$data.stocks.push(this.$data.stock);
      this.$data.stock = {};
    },
    prepareStock() {
      return {
        items: this.$data.stocks,
        purchaseId: this.$route.params.id,
      };
    },
    updateStock() {
      window.axios.post("/stock", this.prepareStock()).then((response) => {
        this.feedback(response.data.message);
        this.$data.stockUpdated = true;
      });
    },
    getPurchaseFromApi() {
      window.axios.get("/order/" + this.$route.params.id).then((response) => {
        this.$data.products = response.data.order.items;
        this.$data.order = response.data.order;
        this.$data.supplier = response.data.supplier;
        this.$data.stockUpdated = response.data.order.stockUpdated;
      });
    },
  },
};
</script>
